import { TFunction } from "i18next";
import * as Yup from "yup";
import { ObjectiveFinalStatusEnum } from "../types/enums";

export const getImprovementPlanFinalizeSchema = (t: TFunction) =>
    Yup.object().shape({
        finalizeReasonId: Yup.number()
            .required(t("common:form.requiredFieldForm"))
            .min(1, t("common:form.requiredFieldForm")),
        objectives: Yup.array()
            .of(
                Yup.object().shape({
                    id: Yup.number().required(),
                    finalStatus: Yup.number()
                        .required(t("common:form.requiredFieldForm"))
                        .oneOf(
                            [
                                ObjectiveFinalStatusEnum.Achieved,
                                ObjectiveFinalStatusEnum.NoAchieved,
                                ObjectiveFinalStatusEnum.PartiallyAchieved,
                                ObjectiveFinalStatusEnum.NoTreated,
                                ObjectiveFinalStatusEnum.NoApply
                            ],
                            t("common:form.requiredFieldForm")
                        )
                })
            )
            .required(t("common:form.requiredFieldForm"))
    });
